import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#FFE0C0',
} as const

export const resources = {
  loginBg: '/images/silktale/login/login-bg.webp',
  logo: '',
  novel: '',
  facebookIcon: '/images/silktale/login/icon-facebook-logo.png',
  googleIcon: '/images/silktale/login/icon-google-logo.png',
  appleIcon: '/images/silktale/login/icon-apple-logo.png',
  emailIcon: '/images/silktale/login/icon-email.png',
  emailCodeIcon: '/images/silktale/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
